import { render } from "./letter-tag-attachment.vue?vue&type=template&id=312ce953"
import script from "./letter-tag-attachment.vue?vue&type=script&lang=js"
export * from "./letter-tag-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__